/**
 * @classdesc Norwegian-Bokmål Language Pack
 * @desc This class will used to translate tokens into the Norwegian-Bokmål language.
 * @namespace Languages.Norwegian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Norwegian
 */
export const dictionary = {
	'years'   : 'År',
	'months'  : 'Måneder',
	'days'    : 'Dager',
	'hours'   : 'Timer',
	'minutes' : 'Minutter',
	'seconds' : 'Sekunder'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Norwegian
 */
export const aliases = ['no', 'nb', 'no-nb', 'norwegian'];
